import { FC } from 'react';

import './style.scss';

export const CampaignSkeleton: FC = () => <div className="campaign-skeleton" />;
